import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithImageSignIn() {
	return <AuthShell variant="with-image"><AuthForm variant="with-image" mode="sign-in" /></AuthShell>;
}

export default AuthWithImageSignIn;
